import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mistral-large',
  templateUrl: './mistral-large.component.html',
  styleUrls: ['./mistral-large.component.scss']
})
export class MistralLargeComponent {
  constructor(public dialogRef: MatDialogRef<MistralLargeComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
